import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Filter } from 'lucide-react';
import { currentRefinements } from 'instantsearch.js/es/widgets';
import styles from './FilterBar.module.scss';

const FilterBar = ({
  search,
  activeCount,
  onOpenFilters,
  pillsContainerRef,
}) => {
  const widgetsMounted = useRef(false);

  useEffect(() => {
    if (!search || !pillsContainerRef?.current || widgetsMounted.current)
      return;
    widgetsMounted.current = true;

    search.addWidgets([
      currentRefinements({
        container: pillsContainerRef.current,
        cssClasses: {
          root: styles.currentRefinementsRoot,
          list: styles.currentRefinementsList,
          item: styles.currentRefinementsItem,
          label: styles.currentRefinementsLabel,
          category: styles.currentRefinementsCategory,
          categoryLabel: styles.currentRefinementsCategoryLabel,
          delete: styles.currentRefinementsDelete,
        },
      }),
    ]);
  }, [search, pillsContainerRef]);

  return (
    <button className={styles.filtersBtn} onClick={onOpenFilters}>
      <Filter size={15} />
      <span>Filters</span>
      {activeCount > 0 && (
        <span className={styles.filtersBadge}>{activeCount}</span>
      )}
    </button>
  );
};

FilterBar.propTypes = {
  search: PropTypes.object,
  activeCount: PropTypes.number.isRequired,
  onOpenFilters: PropTypes.func.isRequired,
  pillsContainerRef: PropTypes.object.isRequired,
};

export default FilterBar;
